import React, {useEffect, useState} from 'react';
import {apiAccess} from "../../../common/components/AxiosWrapper";
import Constants from "../../../common/components/constants";
import Spinner from "../Spinner/Spinner";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';


function Instagram(props) {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isEnableOpen, setEnableModalParam] = useState(false);
    const [isDisableOpen, setDisableModalParam] = useState(false);
    const [isAlertOpen, setAlertModalParam] = useState(false);
    const [isCreateOpen, setCreateModalParam] = useState(false);
    const [contentId, setContentId] = useState(null)
    const [channelIdInput, setChannelIdInput] = useState("")
    const [errorMessage, setErrorMessage] = useState("");


    useEffect(() => {
        loadInstagramList();
    }, [])
    /**
     * Instagramの読み込み　
     */
    const loadInstagramList = () => {
        setLoading(true)
        apiAccess.get(
            Constants.URLs.GET_INSTAGRAM_ACCOUNT)
            .then((response) => {
                const successJson = response.data;
                setLoading(false)
                setList(successJson?.data ?? []);
                const expired = (successJson?.data ?? [])
                .filter(
                    (acc) =>
                    acc.linked_instagram_account_data_expire_datetime &&
                    new Date(acc.linked_instagram_account_data_expire_datetime) <
                        new Date(),
                )
                .map(
                    (acc) =>
                    `アカウントの有効期限（${acc.linked_instagram_account_data_expire_datetime}）が切れています。再連携するには「新規登録」ボタンからログインしてください。`,
                );

                if (props.onExpiredMessages) {
                props.onExpiredMessages(expired);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const toggleItemChange = (bool) => {
        apiAccess.post(
            bool ? Constants.URLs.ENABLE_INSTAGRAM_ACCOUNT : Constants.URLs.DISABLE_INSTAGRAM_ACCOUNT, {
                "user_id": props.auth.userId,
                "linked_instagram_account_id": contentId
            })
            .then((response) => {
                const successJson = response.data;
                setLoading(false);
                toggleEnableModal(false)
                toggleDisableModal(false)
                successJson?.data && setList(successJson?.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const getOAuth = () => {
        apiAccess.get(
            Constants.URLs.OAUTH_INSTAGRAM_ACCOUNT, {
                "linked_instagram_account_id": channelIdInput
            })
            .then((response) => {
                const successJson = response.data;
                setLoading(false);
                toggleCreateModal(false);
                successJson?.data && setList(successJson?.data);
            })
            .catch((error) => {
                console.log(error);
                console.log(error.response)
                setErrorMessage(error?.response?.data?.message ? error.response.data.message : "不明なエラーが発生しました");
                setAlertModalParam(true)
            });
    }


    const toggleEnableModal = (bool) => {
        setEnableModalParam(bool)
    }
    const toggleDisableModal = (bool) => {
        setDisableModalParam(bool)
    }
    const toggleCreateModal = (bool) => {
        setCreateModalParam(bool)
    }
    const toggleAlertModal = (bool) => {
        setAlertModalParam(bool)
    }

    return (
        <div>
            <div className={"console_wrapper"}>
                <Button
                    variant="contained"
                    startIcon={<CreateIcon />}
                    color={"primary"}
                    disableElevation
                    onClick={() => { toggleCreateModal(true); }}
                >
                    新規登録
                </Button>
            </div>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer sx={{ maxHeight: window.innerHeight  }}>
                    {loading ?
                        <Spinner/> :
                        <Table aria-label="facebook list table">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{background:"#f8f8f8"}}>名前</TableCell>
                                    <TableCell sx={{background:"#f8f8f8"}}>カテゴリ</TableCell>
                                    <TableCell className={"table_cell_datetime"} sx={{background:"#f8f8f8"}}>追加日</TableCell>
                                    <TableCell className={"table_cell_datetime"} sx={{background:"#f8f8f8"}}>有効期限</TableCell>
                                    <TableCell className={"table_cell_enable_check"} sx={{background:"#f8f8f8"}}/>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {list.map((value, index) => (
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row">
                                            {value.linked_instagram_account_name}
                                        </TableCell>
                                        <TableCell>{value.linked_instagram_account_category}</TableCell>
                                        <TableCell>{value.linked_instagram_account_add_datetime}</TableCell>
                                        <TableCell>
                                        <span
                                            style={{
                                            color:
                                                new Date(
                                                value.linked_instagram_account_data_expire_datetime,
                                                ) < new Date()
                                                ? "red"
                                                : undefined,
                                            }}
                                        >
                                            {value.linked_instagram_account_data_expire_datetime}
                                        </span>
                                        </TableCell>
                                        <TableCell align={"right"}>
                                            {value.linked_instagram_account_enabled ?
                                                <IconButton aria-label="delete" color="primary" onClick={() => {
                                                    setContentId(value.linked_instagram_account_id)
                                                    toggleDisableModal(true);
                                                }}>
                                                    <CheckBoxIcon/>
                                                </IconButton>
                                                :
                                                <IconButton aria-label="delete" color="primary" onClick={() => {
                                                    setContentId(value.linked_instagram_account_id)
                                                    toggleEnableModal(true);
                                                }}>
                                                    <CheckBoxOutlineBlankIcon/>
                                                </IconButton>
                                            }
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    }
                </TableContainer>
            </Paper>

            <Dialog
                open={isCreateOpen}
                onClose={() => toggleCreateModal(false)}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                maxWidth={"sm"}
                fullWidth={true}
            >
                <DialogTitle>新規追加</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        InstagramページのOAuth処理を行います。<br/>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button size={"large"} onClick={() => toggleCreateModal(false)} color="primary">
                        キャンセル
                    </Button>
                    <Button size={"large"} variant="contained"
                            onClick={() => {
                                window.location.href = Constants.URLs.OAUTH_INSTAGRAM_ACCOUNT;
                            }}
                            color="primary">
                        OAuth
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={isAlertOpen}
                onClose={() => toggleAlertModal(false)}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <DialogTitle>{"エラー"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{errorMessage}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={() => toggleAlertModal(false)} color="primary">
                        閉じる
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={isDisableOpen}
                onClose={() => toggleDisableModal(false)}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <DialogTitle>{"無効化の確認"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>選択したInstagramページからの情報取得を無効にしますが、よろしいですか</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => toggleDisableModal(false)} color="primary">
                        キャンセル
                    </Button>
                    <Button variant="contained" onClick={() => toggleItemChange(false)} color="primary">
                        無効にする
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={isEnableOpen}
                onClose={() => toggleEnableModal(false)}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <DialogTitle>{"有効化の確認"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>選択したInstagramページからの情報取得を有効にしますが、よろしいですか</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => toggleEnableModal(false)} color="primary">
                        キャンセル
                    </Button>
                    <Button variant="contained" onClick={() => toggleItemChange(true)} color="primary">
                        有効にする
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default Instagram;